"use client";

import Link from "next/link";
import { SETTINGS_SECTIONS } from "@/lib/settingsSections";

/** The settings sections, with the current one marked. */
export function SettingsNav({
  pathname,
  onCloseDrawer,
}: {
  pathname: string;
  onCloseDrawer: () => void;
}) {
  return (
    <nav aria-label="Settings navigation" className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
      <p className="px-2 pb-2 text-[11px] font-medium uppercase tracking-wider text-zinc-500">Settings</p>
      {SETTINGS_SECTIONS.map(section => {
        const href = `/settings/${section.id}`;
        const active = pathname === href;
        return <Link key={section.id} href={href} onClick={onCloseDrawer} aria-current={active ? "page" : undefined} className={`block rounded-lg px-3 py-2.5 text-sm font-medium transition ${active ? "bg-violet-600/15 text-violet-200" : "text-zinc-400 hover:bg-zinc-800/60 hover:text-zinc-100"}`}>
          {section.label}
        </Link>;
      })}
    </nav>
  );
}
